import {
  Button,
  Flex,
  Image,
  Link,
  Stack,
  Text,
  useColorMode,
  Icon,
  useColorModeValue,
} from "@chakra-ui/react";
import { RiVipCrown2Fill} from "react-icons/ri";
import React from "react";
import { useHistory,useLocation } from "react-router-dom";
export function SidebarHelp(props) {
  // Pass the computed styles into the `__css` prop
const history = useHistory();
  
  const { children, sidebarVariant, ...rest } = props;
  const textColor = useColorModeValue("gray.700", "white");
  const { colorMode } = useColorMode();
  return (
    <Stack
      justify='center'
      direction='column'
      align='center'
      spacing='20px'
      mb="22px"
      mt="auto"
      mx='20px'>
      <Link onClick={()=>history.push('/admin/guide')} minW='100%'>
        <Button variant='primary' minW='100%'>
          راهنمای استفاده
        </Button>
      </Link>
      <Link onClick={()=>history.push('/admin/profile')} minW='100%'>
        
          <Button
            variant={colorMode === "light" ? 'dark' : "navy"}
            minW='100%'
            mb={window.innerWidth <= 1024 && "12px"}>
            <Icon as={RiVipCrown2Fill} color="goldenrod" fontSize='lg' />
           <Text mr="15px">
           ارتقای پلن
           </Text>
          </Button>
        
      </Link>
    </Stack>
  );
}
